import { SeoPageLayout } from "@/components/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoSection";
import { SeoFeatureGrid } from "@/components/seo/SeoFeatureGrid";
import { Building2, MapPin, Landmark, GraduationCap } from "lucide-react";

const KomikLublin = () => (
  <SeoPageLayout title="Komik i stand-up" titleAccent="Lublin">
    <SeoSection title="Występy komediowe w Lublinie">
      <p>Lublin to największe miasto wschodniej Polski, ważny ośrodek akademicki i biznesowy. Oferujemy profesjonalne występy komediowe na terenie Lublina i województwa lubelskiego. Nasi komicy doskonale sprawdzają się na eventach firmowych, konferencjach i spotkaniach integracyjnych organizowanych w tym dynamicznie rozwijającym się mieście.</p>
    </SeoSection>
    <SeoSection title="Eventy firmowe w Lublinie">
      <p>Lublin to rosnący hub IT i biznesowy wschodniej Polski. Firmy z branży technologicznej, edukacyjnej i usługowej organizują tu coraz więcej eventów korporacyjnych. Stand-up komediowy doskonale wpisuje się w atmosferę lubelskich spotkań firmowych, łącząc profesjonalizm z wyjątkowym klimatem tego historycznego miasta.</p>
    </SeoSection>
    <SeoSection title="Popularne lokalizacje eventowe w Lublinie">
      <SeoFeatureGrid features={[
        { icon: Landmark, title: "Centrum Spotkania Kultur", description: "Nowoczesna przestrzeń konferencyjna i eventowa" },
        { icon: Building2, title: "Hotele", description: "Focus, Hampton by Hilton, Hotel Vanilla" },
        { icon: MapPin, title: "Stare Miasto", description: "Restauracje i sale bankietowe w historycznym centrum" },
        { icon: GraduationCap, title: "Centra uczelniane", description: "Centrum Konferencyjne UMCS i inne" },
      ]} />
    </SeoSection>
    <SeoSection title="Zamów komika w Lublinie">
      <p>Organizujesz event firmowy w Lublinie lub na Lubelszczyźnie? Skontaktuj się z nami - zaproponujemy format występu komediowego idealnie dopasowany do Twojego wydarzenia i publiczności.</p>
    </SeoSection>
  </SeoPageLayout>
);

export default KomikLublin;
